import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceDetail.css';

const ServiceDetail = ({ service }) => {
  if (!service) return null;

  return (
    <div className="service-detail">
      {/* About This Service - Image Left 62%, Text Right 38% */}
      <div className="sd-details-section">
        <div className="sd-details-container">
          <div className="sd-details-row">
            <div className="sd-details-image">
              <img src={process.env.PUBLIC_URL + service.image} alt={service.name} />
            </div>
            <div className="sd-details-text">
              <h4 className="sd-hero-subtitle">{service.hero?.heading}</h4>
              <h2>About This Service</h2>
              <p>{service.hero?.subheading}</p>
              <p>{service.hero?.details}</p>
              <div className="sd-highlights">
                {service.hero?.features.map((feature, index) => (
                  <div className="sd-highlight-item" key={index}>
                    <span className="sd-highlight-icon">✓</span>
                    <span>{feature.title} - {feature.desc}</span>
                  </div>
                ))}
              </div>
              <Link to="/contact" className="sd-cta-btn">{service.buttonText}</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Process/Features Section */}
      <div className="sd-features-section">
        <div className="sd-features-container">
          <h2 className="sd-features-title">Our Process</h2>
          <div className="sd-features-grid">
            {service.hero?.features.map((feature, index) => (
              <div className="sd-feature-card" key={index}>
                <span className="sd-feature-number">{String(index + 1).padStart(2, '0')}</span>
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Related Products */}
      {service.products && service.products.length > 0 && (
        <div className="sd-products-section">
          <div className="sd-products-container">
            <h2 className="sd-products-title">Products We Supply</h2>
            <p className="sd-products-subtitle">Quality equipment related to this service</p>
            <div className="sd-products-grid">
              {service.products.map((product, index) => (
                <div className="sd-product-card" key={index}>
                  <img src={process.env.PUBLIC_URL + product.image} alt={product.name} />
                  <h4>{product.name}</h4>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <div className="sd-cta-section">
        <div className="sd-cta-container">
          <h2>Need {service.name}?</h2>
          <p>Contact us today for professional service and quality products.</p>
          <Link to="/contact" className="sd-cta-btn">Order or Buy From Us</Link>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetail;
